<div class="registrar-container">
  <h2>Registrar Cliente</h2>

  <!-- Button to start/restart -->
  <div *ngIf="expired && !loading" class="start-section">
    <p>Generá un código QR para que el cliente escanee y comience su registro.</p>
    <button mat-raised-button color="primary" class="action-btn" (click)="startCycle()">
      <mat-icon>qr_code_2</mat-icon>
      Generar QR
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading && !qrUrl" class="loading-container">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Generando enlace...</p>
  </div>

  <!-- QR Display -->
  <div *ngIf="qrUrl && !expired" class="qr-display">
    <p>El cliente debe escanear este código QR con su celular:</p>
    <div class="qr-code-wrapper">
      <qrcode [qrdata]="qrUrl" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
    </div>
    <a *ngIf="!isProduction" class="qr-url-hint" [href]="qrUrl" target="_blank">{{ qrUrl }}</a>
    <p class="refresh-hint">El QR se actualiza automáticamente</p>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="error-message">
    <mat-icon>error</mat-icon>
    {{ errorMessage }}
  </div>
</div>
